<template>
  <Loader class="load-auth-data" v-if="isAuthLoading"/>
  <div class="has-error-loading" v-else-if="hasErrorLoading">Что-то пошло не так</div>
  <div v-else class="app">
    <messages/>
    <div v-if="width > 800" class="w-100">
      <main-header v-if="showMainHeader"/>
      <user-header v-if="showUserHeader"/>
    </div>
    <mobile-header :is-authorized="isAuthorized" v-else />

    <div class="content" :class="{'login': !isAuthorized}">
      <router-view v-if="isAuthorized"/>
      <login v-else/>
    </div>
  </div>
</template>

<style scoped lang="scss">

.app {
  width: 100%;
  min-height: 100vh;
  background-image: url(/static-frontend/bg.png);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  flex-direction: column;
  padding: 40px 60px 40px 160px;
  align-items: flex-start;

  .content {
    width: 100%;
    background: var(--common-background-shape);
    border-radius: 20px;
    min-height: 200px;
    overflow: hidden;
    max-width: 1280px;
    position: relative;
    height: fit-content;
    box-shadow: var(--common-content-box-shadow);

    &.login {
      max-width: 500px;
    }
  }
}

.load-auth-data {
  height: 100vh;
}

.has-error-loading {
  width: 100vw;
  padding: 1rem;
  background: #eee;
  text-align: center;

}
@media (max-width: 1200px) {
  .app {
    padding: 20px 30px 20px 130px;
  }
}

@media (max-width: 800px) {
  .app {
    padding: .5em;

    .content.login {
      align-self: center;
    }
  }
}


</style>
<script>
import MainHeader from "@/components/MainHeader";
import useLogin from "@/composables/UseLogin";
import useJWT from "@/composables/UseJWT";
import Login from "@/views/Login";
import Loader from "@/components/common/Loader";
import UserHeader from "@/components/UserHeader";
import Messages from "@/components/Messages";
import MobileHeader from "@/components/MobileHeader";

export default {
  components: {MobileHeader, Messages, UserHeader, Loader, Login, MainHeader},
  setup() {
    return {
      ...useLogin(),
      isAuth: useJWT().createJWTService()
    }
  },
  mounted() {
    this.isAuth.then(() => {
      this.isAuthLoading = false
    })
      .catch(() => {
        this.isAuthLoading = false
        this.hasErrorLoading = true
      })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  data() {
    return {
      isAuthLoading: true,
      hasErrorLoading: false,
      width: window.innerWidth
    }
  },
  computed: {
    title() {
      return this.isAuthorized
        ? this.$route.meta.title
        : document.title = this.$router.getRoutes().find(i => i.name === 'Login').meta.title
    },
    showMainHeader() {
      return this.$route.name !== 'PageNotFound'
    },
    showUserHeader() {
      return this.isAuthorized && this.$route.name !== 'PageNotFound'
    }
  },
  methods: {
    onResize() {
      this.width = window.innerWidth
    }
  },
  watch: {
    title(newTitle) {
      document.title = newTitle
    }
  }
}
</script>
